const Sdata = {
  shopItems: [
    {
      id: 7,
      cover: "./images/shops/shops-1.png",
      name: "Mapple Earphones",
      price: "180",
      discount: "25",
    },
    {
      id: 8,
      cover: "./images/shops/shops-2.png",
      name: "Vivo android one",
      price: "120",
      discount: "10",
    },
    {
      id: 9,
      cover: "./images/shops/shops-3.png",
      name: "Sony Light",
      price: "20",
      discount: "50 ",
    },
    {
      id: 10,
      cover: "./images/shops/shops-4.png",
      name: "Iphone",
      price: "999",
      discount: "10 ",
    },
    {
      id: 11,
      cover: "./images/shops/shops-5.png",
      name: "Ceats wireless earphone",
      price: "80",
      discount: "20 ",
    },
    {
      id: 12,
      cover: "./images/shops/shops-7.png",
      name: "Redimi Phone",
      price: "400",
      discount: "20 ",
    },
    {
      id: 13,
      cover: "./images/shops/shops-8.png",
      name: "Xeats Bluetooth earphones",
      price: "60",
      discount: "5 ",
    },
    {
      id: 14,
      cover: "./images/shops/shops-9.png",
      name: "Airpod",
      price: "120",
      discount: "10",
    },
    {
      id: 15,
      cover: "./images/shops/shops-10.png",
      name: "Silver Cap",
      price: "5",
      discount: "2",
    },
  ],
}
export default Sdata
